"use client"

import { useSearchParams, useRouter, usePathname } from "next/navigation"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import { SlidersHorizontal } from "lucide-react"
import CustomButton from "../../components/CustomButton"
import { Heading } from "@/components/ui/Heading"
import { cn } from "@/core/lib/utils"
import { getOptions } from "@/constants/options"
import { useDictionary } from "@/core/hooks/use-dictionary"

type SortOption = "" | "popular" | "cheapest" | "expensive" | "oldest"

export function ProductSortSidebar() {
    const searchParams = useSearchParams()
    const router = useRouter()
    const pathname = usePathname()
    const { dictionary } = useDictionary();

    const { SORT_OPTIONS } = getOptions(dictionary);


    const currentValue = (searchParams.get("sort_by") as SortOption) || ""
    const currentLabel = SORT_OPTIONS.find((opt) => opt.value === currentValue)?.label
    const updateSort = (value: SortOption) => {
        const params = new URLSearchParams(searchParams.toString())
        value === "" ? params.delete("sort_by") : params.set("sort_by", value)
        router.push(`${pathname}?${params}`)
    }

    return (
        <Sheet>
            <SheetTrigger asChild>
                <CustomButton
                    variant="outline"
                    size="sm"
                >
                    <SlidersHorizontal className="ml-2 h-3.5 w-3.5" />
                    {currentLabel}
                </CustomButton>
            </SheetTrigger>

            <SheetContent side="right" className="w-[340px] sm:w-[400px]">
                <SheetHeader className="mb-8">
                    <SheetTitle asChild>
                        <Heading className="pb-2" level={3}>
                            {dictionary.ui.sort.title}
                        </Heading>
                    </SheetTitle>
                </SheetHeader>

                <div className="space-y-5 p-4">
                    {SORT_OPTIONS.map((option) => {
                        const isSelected = currentValue === option.value
                        return (
                            <div
                                key={option.value}
                                onClick={() => updateSort(option.value)}
                                onPointerDown={(e) => e.stopPropagation()}
                                className="flex items-center justify-between gap-3 cursor-pointer select-none"
                            >
                                {/* متن راست */}
                                <div className="text-sm font-medium text-right flex-1">{option.label}</div>

                                {/* ایندیکیتور چپ */}
                                <div
                                    className={cn(
                                        "w-4 h-4 rounded-full border border-muted-foreground shrink-0 transition-colors duration-200",
                                        isSelected ? "bg-black" : "bg-transparent"
                                    )}
                                />
                            </div>
                        )
                    })}
                </div>
            </SheetContent>
        </Sheet>
    )
}
